"use strict";

var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PhotoboothChoiceCell;
var _react = _interopRequireWildcard(require("react"));
var _html2canvas = _interopRequireDefault(require("html2canvas"));
var _qrcode = require("qrcode.react");
var _AzertyKeyboard = _interopRequireDefault(require("./AzertyKeyboard"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function PhotoboothChoiceCell(_ref2) {
  var cell = _ref2.cell,
    screenType = _ref2.screenType,
    language = _ref2.language,
    project = _ref2.project,
    logEvent = _ref2.logEvent,
    page = _ref2.page,
    intl = _ref2.intl;
  var _ref3 = (0, _react.useState)(false),
    _ref4 = _slicedToArray(_ref3, 2),
    isInitialized = _ref4[0],
    setIsInitialized = _ref4[1];
  var _ref5 = (0, _react.useState)(null),
    _ref6 = _slicedToArray(_ref5, 2),
    error = _ref6[0],
    setError = _ref6[1];
  var _ref7 = (0, _react.useState)(true),
    _ref8 = _slicedToArray(_ref7, 2),
    loading = _ref8[0],
    setLoading = _ref8[1];
  var videoRef = (0, _react.useRef)(null);
  var _ref9 = (0, _react.useState)(3),
    _ref0 = _slicedToArray(_ref9, 2),
    count = _ref0[0],
    setCount = _ref0[1]; // Count to track the number of photos taken
  var _ref1 = (0, _react.useState)([]),
    _ref10 = _slicedToArray(_ref1, 2),
    photos = _ref10[0],
    setPhotos = _ref10[1]; // Array to store the photos taken
  var _ref11 = (0, _react.useState)({
      index: 0,
      photoUri: null
    }),
    _ref12 = _slicedToArray(_ref11, 2),
    currentPhoto = _ref12[0],
    setCurrentPhoto = _ref12[1]; // Current photo being captured
  var _ref13 = (0, _react.useState)(0),
    _ref14 = _slicedToArray(_ref13, 2),
    step = _ref14[0],
    setStep = _ref14[1]; // Step to track the current state of the photobooth
  var _ref15 = (0, _react.useState)(false),
    _ref16 = _slicedToArray(_ref15, 2),
    printed = _ref16[0],
    setPrinted = _ref16[1]; // Track if the photo has been printed
  var _ref17 = (0, _react.useState)(""),
    _ref18 = _slicedToArray(_ref17, 2),
    email = _ref18[0],
    setEmail = _ref18[1]; // Email input for sending the photo
  var _ref19 = (0, _react.useState)(""),
    _ref20 = _slicedToArray(_ref19, 2),
    link = _ref20[0],
    setLink = _ref20[1]; // Link for QR code generation
  var _ref21 = (0, _react.useState)(false),
    _ref22 = _slicedToArray(_ref21, 2),
    isSending = _ref22[0],
    setIsSending = _ref22[1]; // Track if the photo is being sent
  var _ref23 = (0, _react.useState)(false),
    _ref24 = _slicedToArray(_ref23, 2),
    emailEditing = _ref24[0],
    setEmailEditing = _ref24[1]; // Track if the email input is being edited
  var _ref25 = (0, _react.useState)(false),
    _ref26 = _slicedToArray(_ref25, 2),
    started = _ref26[0],
    setStarted = _ref26[1]; // Track if the photo has been sent
  var _ref27 = (0, _react.useState)(false),
    _ref28 = _slicedToArray(_ref27, 2),
    emailSended = _ref28[0],
    setEmailSended = _ref28[1]; // Track if the email has been sent
  var _ref29 = (0, _react.useState)(null),
    _ref30 = _slicedToArray(_ref29, 2),
    currentDataUri = _ref30[0],
    setCurrentDataUri = _ref30[1]; // Current data URI of the photo being captured

  (0, _react.useEffect)(function () {
    function startCamera() {
      return _startCamera.apply(this, arguments);
    }
    function _startCamera() {
      _startCamera = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var stream, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return navigator.mediaDevices.getUserMedia({
                video: {
                  width: {
                    ideal: 1080
                  },
                  height: {
                    ideal: 1660
                  },
                  facingMode: "user" // ou 'environment' selon la caméra souhaitée
                }
              });
            case 1:
              stream = _context.v;
              if (videoRef.current) {
                videoRef.current.srcObject = stream;
                videoRef.current.play();
              }
              setIsInitialized(true);
              setLoading(false);
              if (videoRef.current) {
                videoRef.current.srcObject = stream;
                videoRef.current.play();
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t2 = _context.v;
              setError(_t2);
              setLoading(false);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      return _startCamera.apply(this, arguments);
    }
    startCamera();
  }, []);
  var handleShare = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
      var previewElement, i, canvas, imageData, image, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            _context3.p = 0;
            previewElement = null;
            i = 0;
          case 1:
            if (!(i < 10)) {
              _context3.n = 4;
              break;
            }
            previewElement = document.querySelector(".card-container");
            if (!previewElement) {
              _context3.n = 2;
              break;
            }
            return _context3.a(3, 4);
          case 2:
            _context3.n = 3;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 100);
            });
          case 3:
            i++;
            _context3.n = 1;
            break;
          case 4:
            if (!(email && !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/.test(email))) {
              _context3.n = 5;
              break;
            }
            throw new Error("Invalid email address");
          case 5:
            setIsSending(true);
            if (previewElement) {
              _context3.n = 6;
              break;
            }
            throw new Error("Preview element not found");
          case 6:
            _context3.n = 7;
            return (0, _html2canvas.default)(previewElement, {
              useCORS: true
            });
          case 7:
            canvas = _context3.v;
            imageData = canvas.toDataURL("image/jpeg");
            image = new Image();
            image.src = imageData;
            image.onload = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
              var originalWidth, originalHeight, rotatedCanvas, ctx, rotatedImageData, response, record;
              return _regenerator().w(function (_context2) {
                while (1) switch (_context2.n) {
                  case 0:
                    originalWidth = image.width;
                    originalHeight = image.height;
                    rotatedCanvas = document.createElement("canvas");
                    ctx = rotatedCanvas.getContext("2d");
                    rotatedCanvas.width = originalHeight;
                    rotatedCanvas.height = originalWidth;
                    ctx.save();
                    ctx.translate(rotatedCanvas.width / 2, rotatedCanvas.height / 2);
                    ctx.rotate(90 * Math.PI / 180);
                    ctx.drawImage(image, -originalWidth / 2, -originalHeight / 2);
                    ctx.restore();
                    rotatedImageData = rotatedCanvas.toDataURL("image/jpeg");
                    setCurrentDataUri(rotatedImageData);
                    _context2.n = 1;
                    return fetch("".concat(project.backEndUri, "/send_photo"), {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json"
                      },
                      body: JSON.stringify({
                        cell_id: cell.id,
                        image: rotatedImageData,
                        email: email || null
                      })
                    });
                  case 1:
                    response = _context2.v;
                    if (response.ok) {
                      _context2.n = 2;
                      break;
                    }
                    throw new Error("Upload failed");
                  case 2:
                    _context2.n = 3;
                    return response.json();
                  case 3:
                    record = _context2.v;
                    setLink(record.image_uri);
                    setEmail("");
                    logEvent("click", {
                      cellId: cell.id,
                      pageId: page.id,
                      languageCode: intl.locale,
                      action: "send_photo",
                      email: email || null,
                      link: record.image_uri
                    });
                    if (email) setEmailSended(true);
                  case 4:
                    return _context2.a(2);
                }
              }, _callee2);
            }));
            _context3.n = 9;
            break;
          case 8:
            _context3.p = 8;
            _t3 = _context3.v;
            console.error("Error sending photo:", _t3);
          case 9:
            _context3.p = 9;
            console.log("Photo sent successfully");
            return _context3.f(9);
          case 10:
            return _context3.a(2);
        }
      }, _callee3, null, [[0, 8, 9, 10]]);
    }));
    return function handleShare(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  function handlePrint() {
    if (printed || !currentDataUri) {
      return;
    }
    if (window.electronAPI) {
      window.electronAPI.sendImageForPrint(currentDataUri);
    }
    if (window.Android && typeof window.Android.postMessage === "function") {
      window.Android.postMessage(currentDataUri);
    }
    setPrinted(true);
    logEvent("click", {
      cellId: cell.id,
      pageId: page.id,
      languageCode: intl.locale,
      action: "print_photo"
    });
  }
  function capturePhotoSequence() {
    if (started) return; // Prevent multiple captures
    setStarted(true);
    var totalPhotos = 3;
    var countdownTime = 4;
    setStep(1);
    setPhotos([]); // reset existing photos

    var currentPhoto = 0;
    function countdownAndCapture() {
      var currentCount = countdownTime;
      var countdownInterval = setInterval(function () {
        setCount(currentCount - 1);
        --currentCount;
        if (currentCount <= 0) {
          clearInterval(countdownInterval);
          captureOnePhoto(function (photo) {
            setPhotos(function (prev) {
              return [].concat(_toConsumableArray(prev), [photo]);
            });
            currentPhoto++;
            if (currentPhoto < totalPhotos) {
              countdownAndCapture();
            } else {
              setStep(2);
            }
          });
        }
      }, 1000);
    }
    countdownAndCapture();
  }
  function captureOnePhoto(callback) {
    var video = videoRef.current;
    if (!video) return;
    var canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var data = imageData.data;
    for (var i = 0; i < data.length; i += 4) {
      var avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
      data[i] = data[i + 1] = data[i + 2] = avg;
    }
    ctx.putImageData(imageData, 0, 0);
    var photoDataUrl = canvas.toDataURL("image/png");
    callback(photoDataUrl);
  }
  if (!isInitialized && loading) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        fontFamily: project ? project.default_button_font : "arial",
        color: cell.text_color,
        width: "100%",
        height: "100%"
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: "60%",
        margin: "auto",
        height: "60%",
        fontSize: "3em",
        textAlign: "center"
      }
    }, "Initializing..."));
  }
  if (error) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        fontFamily: project ? project.default_button_font : "arial",
        color: "red",
        width: "100%",
        height: "100%"
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: "80%",
        margin: "auto",
        height: "80%",
        fontSize: "2em",
        textAlign: "center"
      }
    }, "Erreur d\u2019acc\xE8s \xE0 la cam\xE9ra : ", error.message));
  }
  switch (step) {
    case 0:
    case 1:
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: project ? project.default_button_font : "arial",
          color: cell.text_color,
          width: "100%",
          height: "100%"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "80%",
          margin: "auto",
          height: "64%",
          border: "solid 0.5em " + cell.border_color
        }
      }, /*#__PURE__*/_react.default.createElement("video", {
        ref: videoRef,
        style: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          filter: "grayscale(100%)",
          transform: "scaleX(-1)"
        },
        autoPlay: true,
        muted: true
      }), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          textAlign: "center",
          fontSize: "2em",
          position: "absolute",
          left: 0,
          width: "100%",
          top: "20%",
          color: cell.text_color,
          display: "flex"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        onClick: function onClick() {
          return capturePhotoSequence();
        },
        style: {
          margin: "auto",
          cursor: "pointer"
        }
      }, step === 0 ? /*#__PURE__*/_react.default.createElement(LoadingSvg, {
        cell: cell,
        animated: false
      }) : step === 1 ? count > 0 ? /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: cell.text_color,
          fontSize: "4em"
        }
      }, count) : /*#__PURE__*/_react.default.createElement(LoadingSvg, {
        cell: cell,
        animated: true
      }) : null, step === 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", null, "Prenez votre photo"))))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "80%",
          margin: "auto",
          height: "20%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "2em",
          gap: "1em"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "flex",
          width: "100%",
          justifyContent: "space-around",
          height: "100%",
          background: "rgba(255,255,255,0.2)"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: "100%"
        }
      }, photos[0] ? /*#__PURE__*/_react.default.createElement("img", {
        src: photos[0],
        alt: "Photo 1",
        style: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          transform: "scaleX(-1)"
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }
      }, "1"))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "flex",
          width: "100%",
          justifyContent: "space-around",
          height: "100%",
          background: "rgba(255,255,255,0.2)"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: "100%"
        }
      }, photos[1] ? /*#__PURE__*/_react.default.createElement("img", {
        src: photos[1],
        alt: "Photo 2",
        style: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          transform: "scaleX(-1)"
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }
      }, "2"))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "flex",
          width: "100%",
          justifyContent: "space-around",
          height: "100%",
          background: "rgba(255,255,255,0.2)"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: "100%"
        }
      }, photos[2] ? /*#__PURE__*/_react.default.createElement("img", {
        src: photos[2],
        alt: "Photo 3",
        style: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          transform: "scaleX(-1)"
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }
      }, "3")))));
    case 2:
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: project ? project.default_button_font : "arial",
          color: cell.text_color,
          width: "100%",
          height: "100%"
        }
      }, /*#__PURE__*/_react.default.createElement("style", null, "\n                            .selectable:hover {\n                                transition-duration: 0.2s;\n                                transition-timing-function: ease-in-out;\n                                cursor: pointer;\n                                opacity: 0.8;\n                                scale: 1.05;\n                                transform-origin: center;\n                            }\n                        "), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "80%",
          margin: "auto",
          height: "64%",
          border: "solid 0.5em " + cell.border_color
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: currentPhoto.photoUri || photos[0],
        alt: "Photo ".concat(currentPhoto.index + 1),
        style: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          border: "0.5em solid" + cell.border_color,
          transform: "scaleX(-1)"
        }
      })), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "80%",
          margin: "auto",
          height: "18%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "2em",
          gap: "1em"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "flex",
          width: "100%",
          justifyContent: "space-around",
          height: "100%"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: "100%"
        }
      }, photos[0] ? /*#__PURE__*/_react.default.createElement("img", {
        className: "selectable",
        onClick: function onClick() {
          setCurrentPhoto({
            index: 0,
            photoUri: photos[0]
          });
        },
        src: photos[0],
        alt: "Photo 1",
        style: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          border: "solid 0.5em " + cell.border_color,
          opacity: currentPhoto.index === 0 ? 1 : 0.6,
          cursor: "pointer",
          transform: "scaleX(-1)",
          background: "rgba(255,255,255,1)"
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "1.2em"
        }
      }, "1"))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "flex",
          width: "100%",
          justifyContent: "space-around",
          height: "100%"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: "100%"
        }
      }, photos[1] ? /*#__PURE__*/_react.default.createElement("img", {
        className: "selectable",
        onClick: function onClick() {
          setCurrentPhoto({
            index: 1,
            photoUri: photos[1]
          });
        },
        src: photos[1],
        alt: "Photo 2",
        style: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          border: "solid 0.5em " + cell.border_color,
          opacity: currentPhoto.index === 1 ? 1 : 0.6,
          cursor: "pointer",
          transform: "scaleX(-1)",
          background: "rgba(255,255,255,1)"
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "1.2em"
        }
      }, "2"))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "flex",
          width: "100%",
          justifyContent: "space-around",
          height: "100%"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: "100%"
        }
      }, photos[2] ? /*#__PURE__*/_react.default.createElement("img", {
        className: "selectable",
        onClick: function onClick() {
          setCurrentPhoto({
            index: 2,
            photoUri: photos[2]
          });
        },
        src: photos[2],
        alt: "Photo 3",
        style: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          border: "solid 0.5em " + cell.border_color,
          opacity: currentPhoto.index === 2 ? 1 : 0.6,
          cursor: "pointer",
          transform: "scaleX(-1)",
          background: "rgba(255,255,255,1)"
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "1.2em"
        }
      }, "3")))), /*#__PURE__*/_react.default.createElement("div", {
        onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                setStep(3);
                setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                  return _regenerator().w(function (_context4) {
                    while (1) switch (_context4.n) {
                      case 0:
                        _context4.n = 1;
                        return handleShare();
                      case 1:
                        return _context4.a(2);
                    }
                  }, _callee4);
                })), 1500);
              case 1:
                return _context5.a(2);
            }
          }, _callee5);
        })),
        style: {
          width: "80%",
          margin: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "2em",
          background: "black",
          padding: "1em"
        }
      }, /*#__PURE__*/_react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "0.7em",
        height: "0.7em",
        viewBox: "0 0 24 22",
        fill: "none"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M22.2404 5.33735H19.5832V0.699167C19.5832 0.312604 19.2662 0 18.8748 0H5.12519C4.73379 0 4.4168 0.312603 4.4168 0.699167V5.33735H1.75957C0.7875 5.33735 0 6.11394 0 7.07197V15.2279C0 16.1865 0.7875 16.9631 1.75957 16.9631H4.4168V21.3008C4.4168 21.6868 4.73379 22 5.12519 22H18.8748C19.2662 22 19.5832 21.6868 19.5832 21.3008V16.9631H22.2404C23.2125 16.9631 24 16.1865 24 15.2279V7.07196C24 6.11393 23.2125 5.33735 22.2404 5.33735ZM5.99883 1.56012H18.0012V5.33735H5.99883V1.56012ZM18.0023 20.4243H18.0012V20.4399H5.99883V20.4243H5.99062V13.9579H18.0023V20.4243ZM19.5832 9.31623C19.5557 9.48379 19.4748 9.63403 19.3582 9.74902C19.2129 9.89289 19.0125 9.9813 18.7904 9.9813H16.7367C16.2932 9.9813 15.934 9.62652 15.934 9.18911C15.934 8.97069 16.0236 8.77249 16.1689 8.6292C16.3143 8.4859 16.5152 8.39749 16.7367 8.39749H18.7904C19.19 8.39749 19.5217 8.68524 19.5832 9.06198C19.5902 9.10359 19.5938 9.14577 19.5938 9.18911C19.5938 9.23244 19.5902 9.27462 19.5832 9.31623Z",
        fill: cell.background_color
      })), /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: cell.text_color,
          fontSize: "1.5em",
          marginLeft: "1em"
        }
      }, "SELECTIONNER LA PHOTO")));
    case 3:
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: project ? project.default_button_font : "arial",
          color: cell.text_color,
          width: "80%",
          height: "100%",
          padding: "1em",
          margin: "auto"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "card-container",
        style: {
          background: "#344F40",
          width: "80%",
          margin: "auto",
          height: "66%",
          border: "solid 1.5em " + cell.border_color,
          padding: "3em",
          textAlign: "center",
          marginLeft: "-1.5em"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          textAlign: "center",
          color: cell.text_color,
          marginBottom: "0.8em",
          marginTop: "-0.6em"
        }
      }, /*#__PURE__*/_react.default.createElement(LogoPrada, null)), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "90%",
          height: "90%",
          border: "1.5em solid white",
          overflow: "hidden",
          textAlign: "center",
          margin: "auto",
          backgroundImage: "url(".concat(currentPhoto.photoUri || photos[0], ")"),
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundColor: "white",
          // ou autre couleur d'arrière-plan pour les bords vides
          transform: "scaleX(-1)"
        }
      }), /*#__PURE__*/_react.default.createElement("p", {
        style: {
          color: cell.text_color,
          fontSize: "1em",
          marginTop: "-2.2em"
        }
      }, "What if there's ", /*#__PURE__*/_react.default.createElement("br", null), "another way?")), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          padding: "1em",
          background: "rgba(255,255,255,0.2)",
          width: "80%",
          margin: "auto",
          height: "16%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "2em",
          gap: "1em",
          flexDirection: "column"
        }
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: cell.text_color,
          fontSize: "0.7em",
          fontWeight: "bold"
        }
      }, "Recevoir ma photo par email ou scanner le QR code"), /*#__PURE__*/_react.default.createElement("br", null)), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          marginTop: "-0.8em"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          flex: 4
        }
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        onClick: function onClick() {
          setEmailEditing(true);
        },
        style: {
          background: "rgba(255,255,255, 0.2)",
          width: "87%",
          color: cell.text_color,
          padding: "0.5em",
          left: 0,
          top: 0,
          fontSize: "0.7em"
        }
      }, email || "Entrez votre email ici"), emailSended && /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: "green",
          fontSize: "0.7em",
          fontWeight: "bold"
        }
      }, "Email envoy\xE9 avec succ\xE8s !"), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "row",
          gap: "0.5em",
          justifyContent: "space-between",
          width: "90%",
          marginTop: "0.1em"
        }
      }, /*#__PURE__*/_react.default.createElement("button", {
        disabled: emailSended,
        style: {
          flex: 1,
          background: "black",
          color: cell.text_color,
          border: "none",
          padding: "0.5em",
          marginTop: "0.6em",
          cursor: "pointer",
          fontSize: "0.6em",
          fontWeight: "bold",
          width: "100%"
        },
        onClick: handleShare
      }, emailSended ? "Email envoyé !" : "Envoyer par email"), /*#__PURE__*/_react.default.createElement("button", {
        disabled: printed,
        style: {
          flex: 1,
          background: "rgba(255,255,255, 0.2)",
          color: cell.text_color,
          border: "none",
          padding: "0.5em",
          marginTop: "1em",
          cursor: "pointer",
          fontSize: "0.6em",
          fontWeight: "bold",
          width: "100%"
        },
        onClick: handlePrint
      }, printed ? "Impression..." : "Imprimer")))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          flex: 1,
          padding: "0.5em",
          marginBottom: "1em"
        }
      }, link && cell.qr_code && /*#__PURE__*/_react.default.createElement(_qrcode.QRCodeSVG, {
        style: {
          width: "5em",
          height: "5em"
        },
        value: link
      })))), emailEditing && /*#__PURE__*/_react.default.createElement(_AzertyKeyboard.default, {
        setVisible: setEmailEditing,
        project: project,
        input: email,
        setInput: setEmail
      }));
  }
}
function LogoPrada() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10em",
    height: "2em",
    viewBox: "0 0 300 50",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("text", {
    x: "150",
    y: "35",
    textAnchor: "middle",
    fill: "white",
    fontSize: "32",
    fontFamily: "Arial, sans-serif",
    fontWeight: "300",
    letterSpacing: "0.15em"
  }, "PRADA"));
}
function LoadingSvg(_ref31) {
  var cell = _ref31.cell,
    animated = _ref31.animated;
  if (!animated) {
    return /*#__PURE__*/_react.default.createElement("svg", {
      style: {
        minWidth: "3.5rem",
        minHeight: "3.5rem",
        color: cell.text_color,
        padding: "1em",
        border: "solid 0.2em " + cell.text_color,
        borderRadius: "50%",
        backdropFilter: "blur(5px)"
      },
      xmlns: "http://www.w3.org/2000/svg",
      width: "40",
      height: "40",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "lucide lucide-camera-icon lucide-camera"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"
    }), /*#__PURE__*/_react.default.createElement("circle", {
      cx: "12",
      cy: "13",
      r: "3"
    }));
  }
  return /*#__PURE__*/_react.default.createElement("svg", {
    style: {
      minWidth: "3.5rem",
      minHeight: "3.5rem",
      color: cell.text_color,
      backdropFilter: "blur(5px)",
      borderRadius: "50%",
      padding: "1em",
      border: "solid 0.2em " + cell.text_color
    },
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 24 24",
    fill: "none",
    className: "lucide lucide-camera-icon lucide-camera"
  }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0%",
    stopColor: "currentColor",
    stopOpacity: "1"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "100%",
    stopColor: "currentColor",
    stopOpacity: "0"
  }))), /*#__PURE__*/_react.default.createElement("style", null, "\n            .spinner {\n                animation: spin 1.5s linear infinite;\n                transform-origin: center;\n                transform-box: fill-box;\n            }\n    \n            @keyframes spin {\n                0% { transform: rotate(0deg); }\n                100% { transform: rotate(360deg); }\n            }\n        "), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("circle", {
    className: animated ? "spinner" : "",
    cx: "12",
    cy: "13",
    r: "3",
    stroke: "url(#grad)",
    strokeWidth: "2",
    fill: "none"
  })));
}